'use client';

import { useUserData } from '@/context/auth/user-data-context';
import { ContentType } from '@/graphql/graphql';
import { useTranslations } from 'next-intl';
import { BuyerSellerDropDown } from '../buyer-seller-dropdown';
import { CategoriesDropDown } from '../catagories-dropdown';
import NavigationLink from '../navigation-link';
import { StudioDropDown } from '../studio-dropdown';
import { useController } from './controller';
import { NavigationProps } from './interfaces';

export const Navigation = ({ isMobile = false, onLinkClickAction }: NavigationProps) => {
    const t = useTranslations('Navigation');
    const th = useTranslations('Header');
    const { isBuyer, isSeller } = useUserData();

    const { categoriesProgram, categoriesFormat, isLinkActive } = useController({
        translateNavigation: t as (key: string) => string,
    });
    const showGuestMenu = !isSeller && !isBuyer;
    return (
        <nav
            className={`text-white transition-all duration-300 ${
                isMobile ? 'flex flex-col gap-2' : 'flex items-center space-x-6'
            }`}
        >
            {showGuestMenu ? (
                <BuyerSellerDropDown
                    isActive={isLinkActive('/tv-rights-buyers') || isLinkActive('/tv-rights-sellers')}
                />
            ) : null}
            {isSeller || isBuyer || showGuestMenu ? (
                <CategoriesDropDown
                    isActive={isLinkActive('/programs')}
                    contentType={ContentType.Program}
                    categories={categoriesProgram}
                    onLinkClickAction={onLinkClickAction}
                />
            ) : null}
            {isSeller || isBuyer || showGuestMenu ? (
                <CategoriesDropDown
                    isActive={isLinkActive('/formats')}
                    contentType={ContentType.Format}
                    categories={categoriesFormat}
                    onLinkClickAction={onLinkClickAction}
                />
            ) : null}
            {isBuyer ? (
                <div className="lg:hidden">
                    <NavigationLink
                        href="/transactions"
                        isActive={isLinkActive('/transactions')}
                        onClick={onLinkClickAction}
                    >
                        {t('transactions')}
                    </NavigationLink>
                </div>
            ) : null}
            {isBuyer || isSeller ? (
                <StudioDropDown isSeller={isSeller} callback={() => !!onLinkClickAction && onLinkClickAction()} />
            ) : null}
            {isBuyer || isSeller ? (
                <div className="lg:hidden">
                    <NavigationLink
                        href="/settings"
                        isActive={isLinkActive('/settings', 'inclusive')}
                        onClick={onLinkClickAction}
                    >
                        {th('accountSettings')}
                    </NavigationLink>
                </div>
            ) : null}
        </nav>
    );
};
